import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/services/http/http.service';
import { User } from '@core/models/user.model';
import { Router } from '@angular/router';
import { Paths } from '@shared/enums/paths.enums';
import { TokenResponse } from '@app/core/models/token-reponse';
import { BehaviorSubject, Observable } from 'rxjs';
import { from } from 'rxjs';
import { Messages } from '@app/shared/enums/messages.enums';
import { LocalStorageService } from '@core/services/localStorage/local-storage.service';
import { RefreshTokenRequest } from '@app/core/models/refresh-token-request';
import { Roles } from '@app/shared/models/roles.model';

@Injectable()
export class AuthService {
  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private httpService: HttpService) { }

  loggedIn = new BehaviorSubject<boolean>(this.isLoggin());

  get isLoggedIn(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }

  isLoggin(): boolean {
    return this.getToken() && this.getToken().length > 0;
  }

  logIn(user: User): Promise<TokenResponse> {
    const url = 'WebAppUserAuthentication/CreateToken';

    return new Promise((resolve, reject) => {
      this.httpService.PostRequest<TokenResponse, User>(url, user).subscribe(response => {
        resolve(response);
        this.loggedIn.next(response.token ? true : false);
      },(error: string) => {
        reject(Messages.notAutorizedLogin);
      });
    });
  }

  getRoles(): Observable<Roles> {
    const url = 'WebAppUser/GetMyInfo';
    return this.httpService.GetRequest<Roles>(url);
  }

  refreshToken(tokenRequest: RefreshTokenRequest = this.getRefreshTokenRequest()): Observable<TokenResponse> {
    const url = 'token/RefreshToken';

    return from(this.httpService.PostRequest<TokenResponse, RefreshTokenRequest>
      (url, tokenRequest));
  }

  logOut(): void {
    this.destroyToken();
    this.loggedIn.next(false);
    this.router.navigate([Paths.login]);
  }

  getToken(): string {
    return this.localStorageService.getkeyName('jwtToken');
  }

  getRefreshToken(): string {
    return this.localStorageService.getkeyName('jwtRefreshToken');
  }

  getRefreshTokenRequest(): RefreshTokenRequest {
    const refresh = new RefreshTokenRequest();

    refresh.refreshToken = this.getRefreshToken();
    refresh.token = this.getToken();
    refresh.userType = 0;

    return refresh;
  }

  saveToken(tokenResponse: TokenResponse): void {
    this.localStorageService.set('jwtToken', tokenResponse.token);
    this.localStorageService.set('jwtRefreshToken', tokenResponse.refreshToken);
  }

  destroyToken(): void {
    this.localStorageService.deleteAll();
  }
}
